/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { FillingStationModel } from './fillingstation';
import { FillingStation } from './fs';
import { HttpManagerService } from '../httpmanager.service';
import { MasterDataConstant } from '../masterdata.constant';
@Injectable()
export class FillingStationService {
    constructor(
        private masterdataservice : MasterDataConstant,
        private httpmanagerService: HttpManagerService
    ) {
    }
    allData(useroffset, pagelimit,status,countrycode,area): Promise<any> {
        var data = {
            offset: useroffset,
            pagelimit: pagelimit,
            status : status,
            countrycode : countrycode,
            area : area
        }
        return this.httpmanagerService.HttpPost('sfillingstation/alldata', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    paginationList(status,countrycode,area): Promise<any> {
        var data = {
            status : status,
            countrycode : countrycode,
            area : area
        }
        return this.httpmanagerService.HttpPost('sfillingstation/paginationlist', JSON.stringify(data), "").then(data => {
            return data
        })
    }
    allsearchingData(useroffset, pagelimit,search): Promise<any> {
        var data = {
            offset: useroffset,
            pagelimit: pagelimit,
            search : search
        }
        return this.httpmanagerService.HttpPost('sfillingstation/allsearchingdata', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    searchfillingstationlist(search): Promise<any> {
        var data = {
            search : search
        }
        return this.httpmanagerService.HttpPost('sfillingstation/searchfillingstationlist', JSON.stringify(data), "").then(data => {
            return data
        })
    }
    arealist(data): Promise<FillingStationModel[]> {
        if(this.masterdataservice.AreaList == undefined)
        {
            this.masterdataservice.AreaList = [];
        }
        if(this.masterdataservice.AreaList.length == 0)
        {
            return this.httpmanagerService.HttpPost('sfillingstation/arealist', JSON.stringify(data), "").then(data => {
                this.masterdataservice.AreaList = data.data;
                return data.data;
            })
        }
        else
        {
            return new Promise( resolve => {
                resolve(this.masterdataservice.AreaList);
              } );
        }
    }
    SaveFillingStation(data): Promise<FillingStation> {
        return this.httpmanagerService.HttpPost('sfillingstation/create', JSON.stringify(data), "").then(data => {
            return data;
        })
    }
    UpdateFillingStation(id, data): Promise<FillingStation> {
        return this.httpmanagerService.HttpPut('sfillingstation', JSON.stringify(data), id).then(data => {
            return data;
        })
    }
    issueData(data): Promise<FillingStationModel[]> {
        return this.httpmanagerService.HttpPost('sfillingstation/issuelist', JSON.stringify(data), "").then(data => {
            return data.data;
        })
    }
    issueSolved(issues): Promise<any> {
        var data = {
            issues : issues
        }
        return this.httpmanagerService.HttpPost('sfillingstation/issuesolved', JSON.stringify(data),"").then(data =>{
            return data
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/fillingstation/fillingstation.service.ts